




























































import Vue from 'vue';
import axios from 'axios';
import ConfigConnection from '@/core/config/config.service';

export default Vue.extend({
  props: { userId: { type: [String, Number], required: true }, surveys: { type: Array, default: () => [] } },
  data() {
    return { rows: [] as any[], loginReport: null as any, loginError: false, loading: true, selectedId: null as any, showLogins: false, requestVersion: 0 };
  },
  computed: {
    selected(): any { return this.rows.find(row => row.id === this.selectedId); }
  },
  watch: { surveys: { handler() { this.load(); }, immediate: true }, userId() { this.load(); } },
  beforeDestroy() { this.requestVersion += 1; },
  methods: {
    async load() {
      const version = ++this.requestVersion;
      this.loading = true;
      if (!this.userId || Array.isArray(this.userId)) return;
      const base = new ConfigConnection().apiInstance;
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('tk_auth')}` }, params: { timezone: 'America/Mexico_City' }, timeout: 10000 };
      const names = { 1: 'Estilo personal', 2: 'Estilo de comunicación', 3: 'MAP', 4: 'SMAP', 5: 'ACT' };
      const surveys = this.surveys as any[];
      const results = await Promise.all([
        axios.get(`${base}activity/users/${this.userId}/logins`, { ...config, params: { ...config.params, all: true } }).then(response => response.data).catch(() => null),
        Promise.all(surveys.map(async assignment => {
          const row = { id: assignment.id, name: names[assignment.surveyId || assignment.SurveyId] || (assignment.survey && assignment.survey.name) || 'Encuesta', report: null, error: false };
          try { row.report = (await axios.get(`${base}activity/surveys/${assignment.id}`, config)).data; }
          catch (error) { row.error = true; }
          return row;
        }))
      ]);
      if (version !== this.requestVersion) return;
      this.loginReport = results[0];
      this.loginError = !results[0];
      this.rows = results[1] as any[];
      const primary = this.rows.find(row => row.report && [3, 4, 5].includes(row.report.surveyId)) || this.rows.find(row => row.report);
      this.selectedId = primary ? primary.id : null;
      this.loading = false;
    },
    duration(seconds: number | null): string {
      if (seconds == null) return '—';
      if (seconds > 0 && seconds < 60) return '< 1 min';
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      return hours ? `${hours} h${minutes % 60 ? ` ${minutes % 60} min` : ''}` : `${minutes} min`;
    },
    count(value: number | null): string { return value == null ? '—' : String(value); },
    dateOnly(value: string): string { const parts = value.split('-'); return `${parts[2]}/${parts[1]}/${parts[0]}`; },
    dateTime(value: string): string { return value ? new Intl.DateTimeFormat('es-MX', { timeZone: 'America/Mexico_City', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(value)) : '—'; }
  }
});
